<template>
  <div class="w-100">
    <file-list :fileType="0" :filePath="'/'"></file-list>
  </div>
</template>

<script>
import FileList from './file/fileList.vue'
export default {
  components: {
    FileList
  }
}
</script>

<style>
</style>